import { createContext } from "react";
import { User } from "library/api";
import { LocalCognitoCodeDelivery } from "./CognitoTypes";
import Carta from "@contextualize/carta";

/** The type of value of {@link UserContext}. */
interface UserContextValue {
  /** The user information if authenticated; otherwise null. */
  user: User | null;

  /** Active Carta session */
  carta: Carta | null;

  /** Whether the user is currently authenticated. */
  authenticated: boolean;

  /** Signs the user in. */
  signIn: (username: string, password: string) => Promise<any | null>;
  /** Signs the user out. */
  signOut: (apiless?: boolean) => Promise<void>;
  /** Completes sign in. */
  completeSignIn: (
    password: string,
    firstname: string,
    lastname: string
  ) => Promise<void>;
  /** Requests password reset. */
  forgotPassword: (
    username: string
  ) => Promise<LocalCognitoCodeDelivery | undefined>;
  /** Reset password. */
  resetPassword: (
    username: string,
    code: string,
    password: string
  ) => Promise<void>;
}

/** A context for user authentication that is updated when authentication is updated */
const UserContext = createContext<UserContextValue>({
  user: null,
  authenticated: false,
  carta: null,
  signIn: async () => null,
  completeSignIn: async () => {},
  signOut: async () => {},
  forgotPassword: async () => undefined,
  resetPassword: async () => undefined,
});

export default UserContext;
export type { UserContextValue };
